// Header query params shared by Compare and its sibling pages (Lion Auto).
// Those pages read their header info (name/date/venue/vivid link) entirely
// from these params, so every caller must supply the same set.
function eventHeaderParams(event) {
  const params = new URLSearchParams();
  params.set('name', event.eventName || 'Event');
  if (event.eventDate) params.set('date', event.eventDate);
  if (event.venue) params.set('venue', event.venue);
  if (event.venueCity) params.set('city', event.venueCity);
  if (event.venueState) params.set('state', event.venueState);
  if (event.vividSeatsEventUrl) params.set('vividUrl', event.vividSeatsEventUrl);
  if (event.chartUrl) params.set('chartUrl', event.chartUrl);
  return params.toString();
}

// Build the Compare page URL for an event. Shared by Dashboard, My Artists
// and the AI attention panel.
export function buildCompareUrl(event) {
  return `/compare/${event.eventId}?${eventHeaderParams(event)}`;
}

// Lion Auto (automation page) for the same event, same header params
export function buildLionAutoUrl(event) {
  return `/lion-auto/${event.eventId}?${eventHeaderParams(event)}`;
}

// Compare ⇄ Lion Auto: the other page for the same event, carrying the
// current page's query string over verbatim so the header reads the same.
// searchParams may be a URLSearchParams (useSearchParams) or a string.
export function siblingPageUrl(basePath, eventId, searchParams) {
  const qs = searchParams ? new URLSearchParams(searchParams).toString() : '';
  return `${basePath}/${encodeURIComponent(eventId)}${qs ? `?${qs}` : ''}`;
}

// Compare always opens in its own tab (its data hooks are tuned for that)
export function openCompare(event) {
  window.open(buildCompareUrl(event), '_blank');
}

// Lion Auto opens in its own tab too
export function openLionAuto(event) {
  window.open(buildLionAutoUrl(event), '_blank');
}
